import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "plan-card-20676__body" }
const _hoisted_2 = { class: "plan-card-20676__title-row" }
const _hoisted_3 = { class: "plan-card-20676__title" }
const _hoisted_4 = {
  key: 0,
  class: "plan-card-20676__badge"
}
const _hoisted_5 = { class: "plan-card-20676__price" }
const _hoisted_6 = { class: "wg-no-translate" }

import { computed } from 'vue'

import type { BillingView, PlanView } from '@/models/billing'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanCard20676',
  props: {
    plan: {},
    billing: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const title = computed(() => `${props.plan.nickname} Plan - 5 Days Free`)

const savingPercentage = computed(() => {
  if (props.plan.id !== 'plan_annual') {
    return null
  }
  return props.billing.switchToAnnualSavings.percent
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["plan-card-20676", { 'plan-card-20676--selected': __props.selected }])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["plan-card-20676__radio", { 'plan-card-20676__radio--selected': __props.selected }])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1),
        (savingPercentage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " SAVE " + _toDisplayString(savingPercentage.value) + "% ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(_toDisplayString(__props.plan.price.perMonth) + "/mo (billed " + _toDisplayString(__props.plan.labels.frequency) + " at ", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.plan.price.perPeriod), 1),
        _cache[0] || (_cache[0] = _createTextVNode(") ", -1))
      ])
    ])
  ], 2))
}
}

})